import { Sell } from "../../models/Sell";
import { UseCase } from '../UseCase';
import { SellRepository } from '../../repositories/SellRepository';

export class GetHistoricUseCase implements UseCase<GetHistoricRequestDto, Sell[]>{
    constructor(
        private sellRepo: SellRepository
    ) { }
    execute(t: GetHistoricRequestDto): Promise<Sell[]> {
        return this.sellRepo.getHistoric(t.token);
    }
}

export class GetHistoricRequestDto {
    constructor(
        public token:string,
    ){}
}